import * as api from '../api/details';
import { FETCH_DETAILS, FETCH_SHORT_DETAILS_SUCCEEDED, UPDATE_NAME } from './ActionTypes';
export const fetchShortDetailsSuccess = model => ({
  type: FETCH_SHORT_DETAILS_SUCCEEDED,
  response: model
});
export const updateInteractiveName = name => ({
  type: UPDATE_NAME,
  name
});
const fetchDetailsStart = () => ({
  type: FETCH_DETAILS.STARTED
});
const fetchDetailsSuccess = response => ({
  type: FETCH_DETAILS.SUCCEEDED,
  payload: response
});
const fetchDetailsFailure = error => ({
  type: FETCH_DETAILS.FAILED,
  error
});
export const fetchFullDetails = id => dispatch => {
  dispatch(fetchDetailsStart());
  api.getInteractiveDetails(id).then(response => {
    dispatch(fetchDetailsSuccess(response));
  }).catch(error => {
    dispatch(fetchDetailsFailure(error));
  });
};